'use client'

import { getTranslate } from 'legacy-src/utilities/i18n'

import { Button } from '@/legacy-src/components/ui/button'

export const CompanyPublicBenefitsButton = () => {
  const { t } = getTranslate()

  return (
    <Button
      onClick={() => {
        window.scrollTo({ top: 0, behavior: 'smooth' })
      }}
    >
      {t('component.button.startUsingBenefits')}
    </Button>
  )
}
